﻿import React, {FC, useMemo} from 'react';
import {
  CollapsableCardBodyItem
} from "./CollapsableCardBodyItem";
import {Link} from "react-router";
import {SlotType} from "../../../types/Slots";

type CollapsableCardBodyLinkItemProps = React.ComponentPropsWithoutRef<'div'> & {
  value: SlotType;
  label: SlotType;
  href?: string;
  hrefTransformFunction?: (value: string) => string;
}

const CollapsableCardBodyLinkItem: FC<CollapsableCardBodyLinkItemProps> = ({
  value,
  label,
  href,
  hrefTransformFunction,
  ...rest
}) => {

  const linkItems: string[] = useMemo(() => {
    const linkItems = [];
    if (value) {
      const parsedItems = String(value)
        .split(',')
        .map(item => item.trim())
        .filter(item => item.length > 0);
      linkItems.push(...parsedItems);
    }

    return linkItems;
  }, [value]);

  return ( linkItems.length === 0 ?
      <CollapsableCardBodyItem value={value} label={label} {...rest} />
    :
      <CollapsableCardBodyItem label={label} value={
        <React.Fragment>
          {linkItems.map((linkItem, index) => (
            <React.Fragment key={`${linkItem}-${index}`}>
              { hrefTransformFunction ?
                <Link to={hrefTransformFunction(linkItem)} target={'_blank'} rel="noopener">{linkItem}</Link>
                :
                <Link to={href || '#'} target={'_blank'} rel="noopener">{linkItem}</Link>
              }
              {(index !== linkItems.length - 1) && ', '}
            </React.Fragment>
          ))}
        </React.Fragment>
      } {...rest} />
  )
}

export { CollapsableCardBodyLinkItem };
